import { prop } from 'ramda'
import { api as baseQuery } from './baseQuery'

export const authApi = baseQuery.injectEndpoints({
  endpoints: ({ mutation }) => ({
    logout: mutation({
      query: () => ({
        method: 'POST',
        url: '/logout'
      })
    }),
    passwordResetEmail: mutation({
      query: body => ({
        body,
        method: 'POST',
        url: '/password/email'
      })
    }),
    resetPassword: mutation({
      query: body => ({
        body,
        method: 'POST',
        url: '/password/reset'
      })
    }),
    signIn: mutation({
      query: body => ({
        body,
        method: 'POST',
        url: `/login?org_domain=${prop('org_domain', body)}`
      }),
      transformResponse: (res, meta, req) => ({
        headers: prop('response', meta),
        req,
        res
      })
    }),
    signUp: mutation({
      query: body => ({
        body,
        method: 'POST',
        url: `/register?org_domain=${prop('org_domain', body)}`
      })
    })
  }),
  reducerPath: 'authApi'
})

export const {
  useLogoutMutation,
  usePasswordResetEmailMutation,
  useResetPasswordMutation,
  useSignInMutation,
  useSignUpMutation
} = authApi
